export default __webpack_public_path__ + "static/media/careplus.824168bb.mp4";